import { IconComponentProps } from '../IconTypes';

const Kanban = ({ className }: IconComponentProps) => (
  <svg
    className={className}
    fill="currentColor"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M5 2.375C3.55025 2.375 2.375 3.55025 2.375 5V19C2.375 20.4497 3.55025 21.625 5 21.625H10C11.4497 21.625 12.625 20.4497 12.625 19V14.425H19C20.4497 14.425 21.625 13.2497 21.625 11.8V5C21.625 3.55025 20.4497 2.375 19 2.375H5ZM11.375 3.625H5C4.24061 3.625 3.625 4.24061 3.625 5V19C3.625 19.7594 4.24061 20.375 5 20.375H10C10.7594 20.375 11.375 19.7594 11.375 19V3.625ZM12.625 3.625V13.175H19C19.7594 13.175 20.375 12.5594 20.375 11.8V5C20.375 4.24061 19.7594 3.625 19 3.625H12.625Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export default Kanban;
